<template>
  <v-app
    :class="{ login: $route.name == 'login' || $route.name == 'nigol' || $route.name == 'allbots' }"
  >
    <v-style>
      :root { --primary-color: {{ $vuetify.theme.primary }}; --bg-login:
      {{
        $vuetify.theme.primary == '#FF706B'
          ? '#ff6868, #ffd8a4'
          : `${$vuetify.theme.primary}, ${shadeColor($vuetify.theme.primary, 174)}`
      }}
      }
    </v-style>
    <router-view></router-view>

    <loading></loading>
  </v-app>
</template>

<script>
import loading from '@/components/elements/loading'
import { mapGetters } from 'vuex'
import api from './api'

export default {
  name: 'App',
  components: {
    loading
  },
  created() {
    // this.checkTokenStatus()
  },
  computed: {
    ...mapGetters(['currentLang', 'isFacebook', 'selectedBot'])
  },
  watch: {
    $route(to, from) {
      // this.checkTokenStatus()
    }
  },
  mounted() {
    this.getCheckinCheckoutLog()
  },
  methods: {
    getCheckinCheckoutLog() {
      const vm = this
      if (vm.selectedBot && vm.$store.state.userid) {
        return new Promise((resolve, reject) => {
          const data = {
            pageid: vm.selectedBot.pageid,
            adminid: vm.$store.state.userid,
            limit: 1,
            offset: 0
          }
          vm.logloading = true
          api.ticket2CommonCheckinCheckoutLog(data, (err, response) => {
            if (err) {
              console.error(err)
              reject()
              return
            }

            vm.logloading = false
            vm.logdata = response.data
            if (
              vm.$store.state.pingLoginTimer === null &&
              response &&
              response.data &&
              response.data[0] &&
              response.data[0].actions === 'check-in'
            ) {
              vm.$store.dispatch('loadUpdatePingLogin')
              vm.$store.commit('SET_CHECK_IN', true)
            }
            resolve()
          })
        })
      }
    },
    shadeColor(color, percent) {
      var R = parseInt(color.substring(1, 3), 16)
      var G = parseInt(color.substring(3, 5), 16)
      var B = parseInt(color.substring(5, 7), 16)

      R = parseInt((R * (100 + percent)) / 100)
      G = parseInt((G * (100 + percent)) / 100)
      B = parseInt((B * (100 + percent)) / 100)

      R = R < 255 ? R : 255
      G = G < 255 ? G : 255
      B = B < 255 ? B : 255

      var RR = R.toString(16).length == 1 ? '0' + R.toString(16) : R.toString(16)
      var GG = G.toString(16).length == 1 ? '0' + G.toString(16) : G.toString(16)
      var BB = B.toString(16).length == 1 ? '0' + B.toString(16) : B.toString(16)

      return '#' + RR + GG + BB
    }
  }
}
</script>

<style lang="scss">
@import './assets/css/app.scss';
@import './assets/css/flex2html.scss';
@import '../node_modules/vue2-editor/dist/vue2-editor.css';
</style>

<style lang="scss" scoped>
#app {
  &.login.application {
    background-image: linear-gradient(to top right, var(--bg-login)) !important;
    background-repeat: no-repeat;
    background-size: cover;
  }

  &.application {
    background: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue